import { cva } from 'class-variance-authority';

const inputBaseStyles = [
    'peer',
    'relative',
    'w-full',
    'select-none',
    'focus:ring-0',
    'form-input',
    'rounded-sm',
    'py-2',
    'px-4',
    'text-base', // TODO: Check with Tom (18px in Figma seem to large)

    'data-[float-label=true]:pb-0',
    'data-[float-label=true]:pt-4'
];

const inputStylesSAG = cva([
    ...inputBaseStyles,
    'text-[#000028]',

    'bg-[#EBF7F8]',
    'border-[#4C4C68]',
    'placeholder:text-[#4C4C68]',

    'hover:bg-[#D1FFF2]',
    'hover:border-[#005159]',
    'hover:placeholder:text-[#000028]',

    'focus:bg-[#D1FFF2]',
    'focus:border-[#4C4C68]',
    'focus:placeholder:text-[#4C4C68]',

    'active:bg-[#D1FFF2]',
    'active:border-[#005159]',

    'data-[invalid=true]:bg-[#FCCCD7]',
    'data-[invalid=true]:border-[#D72339]',
    'data-[invalid=true]:placeholder:text-[#000028]',
    'data-[invalid=true]:hover:bg-[#FCCCD7]',
    'data-[invalid=true]:hover:border-[#D72339]',
    'data-[invalid=true]:hover:placeholder:text-[#000028]',
    'data-[invalid=true]:active:bg-[#FCCCD7]',
    'data-[invalid=true]:active:border-[#D72339]',
    'data-[invalid=true]:active:placeholder:text-[#000028]',
    'data-[invalid=true]:focus:bg-[#FCCCD7]',
    'data-[invalid=true]:focus:border-[#D72339]',
    'data-[invalid=true]:focus:placeholder:text-[#000028]',

    'disabled:bg-[#EBF7F8]',
    'disabled:border-[#CCCCD4]',
    'disabled:placeholder:text-[#4C4C68]',
    'disabled:hover:bg-[#EBF7F8]',
    'disabled:hover:border-[#CCCCD4]',
    'disabled:hover:placeholder:text-[#4C4C68]',
    'disabled:focus:bg-[#EBF7F8]',
    'disabled:focus:border-[#CCCCD4]',
    'disabled:focus:placeholder:text-[#4C4C68]',

    'read-only:bg-white',
    'read-only:border-[#CCCCD4]',
    'read-only:placeholder:text-[#4C4C68]',
    'read-only:hover:bg-white',
    'read-only:hover:border-[#CCCCD4]',
    'read-only:hover:placeholder:text-[#4C4C68]',
    'read-only:focus:bg-white',
    'read-only:focus:border-[#CCCCD4]',
    'read-only:focus:placeholder:text-[#4C4C68]',

    'dark:text-white',

    'dark:bg-[#00183B]',
    'dark:border-[#B3B3BE]',
    'dark:placeholder:text-[#B3B3BE]',

    'dark:hover:bg-[#001F39]',
    'dark:hover:border-[#00FFB9]',
    'dark:hover:placeholder:text-white',

    'dark:focus:bg-[#001F39]',
    'dark:focus:border-[#00FFB9]',
    'dark:focus:placeholder:text-[#B3B3BE]',

    'dark:active:bg-[#001F39]',
    'dark:active:border-[#00FFB9]',

    'dark:data-[invalid=true]:bg-[#331131]',
    'dark:data-[invalid=true]:border-[#FF2640]',
    'dark:data-[invalid=true]:placeholder:text-[#FFFFFF]',
    'dark:data-[invalid=true]:hover:bg-[#331131]',
    'dark:data-[invalid=true]:hover:border-[#FF2640]',
    'dark:data-[invalid=true]:hover:placeholder:text-[#FFFFFF]',
    'dark:data-[invalid=true]:active:bg-[#331131]',
    'dark:data-[invalid=true]:active:border-[#FF2640]',
    'dark:data-[invalid=true]:active:placeholder:text-[#FFFFFF]',
    'dark:data-[invalid=true]:focus:bg-[#331131]',
    'dark:data-[invalid=true]:focus:border-[#FF2640]',
    'dark:data-[invalid=true]:focus:placeholder:text-[#FFFFFF]',

    'dark:disabled:bg-[#262648]',
    'dark:disabled:border-[#4C4C68]',
    'dark:disabled:placeholder:text-[#737389]',
    'dark:disabled:hover:bg-[#262648]',
    'dark:disabled:hover:border-[#4C4C68]',
    'dark:disabled:hover:placeholder:text-[#737389]',
    'dark:disabled:focus:bg-[#262648]',
    'dark:disabled:focus:border-[#4C4C68]',
    'dark:disabled:focus:placeholder:text-[#737389]',

    'dark:read-only:bg-[#000028]',
    'dark:read-only:border-[#333353]',
    'dark:read-only:placeholder:text-[#B3B3BE]',
    'dark:read-only:hover:bg-[#000028]',
    'dark:read-only:hover:border-[#333353]',
    'dark:read-only:hover:placeholder:text-[#B3B3BE]',
    'dark:read-only:focus:bg-[#000028]',
    'dark:read-only:focus:border-[#333353]',
    'dark:read-only:focus:placeholder:text-[#B3B3BE]'
]);

const inputStylesSHS = cva([
    ...inputBaseStyles,
    'text-[#1a1a1a]',

    'bg-[#ededed]',
    'border-[#666666]',
    'placeholder:text-[#666666]',

    'hover:bg-[#ededed]',
    'hover:border-[#666666]',
    'hover:placeholder:text-[#666666]',

    'focus:bg-[#ededed]',
    'focus:border-[#666666]',
    'focus:placeholder:text-[#666666]',

    'active:bg-[#ededed]',
    'active:border-[#005159]',

    'data-[invalid=true]:bg-[#ededed]',
    'data-[invalid=true]:border-[#e7001e]',
    'data-[invalid=true]:placeholder:text-[#666666]',
    'data-[invalid=true]:hover:bg-[#ededed]',
    'data-[invalid=true]:hover:border-[#e7001e]',
    'data-[invalid=true]:hover:placeholder:text-[#666666]',
    'data-[invalid=true]:active:bg-[#ededed]',
    'data-[invalid=true]:active:border-[#e7001e]',
    'data-[invalid=true]:active:placeholder:text-[#666666]',
    'data-[invalid=true]:focus:bg-[#ededed]',
    'data-[invalid=true]:focus:border-[#e7001e]',
    'data-[invalid=true]:focus:placeholder:text-[#666666]',

    'disabled:bg-[#f8f8f8]',
    'disabled:border-[#c2c2c2]',
    'disabled:placeholder:text-[#4C4C68]',
    'disabled:hover:bg-[#f8f8f8]',
    'disabled:hover:border-[#c2c2c2]',
    'disabled:hover:placeholder:text-[#4C4C68]',
    'disabled:focus:bg-[#f8f8f8]',
    'disabled:focus:border-[#c2c2c2]',
    'disabled:focus:placeholder:text-[#4C4C68]',

    'read-only:bg-[#ededed]',
    'read-only:border-[#666666]',
    'read-only:placeholder:text-[#666666]',
    'read-only:hover:bg-[#ededed]',
    'read-only:hover:border-[#666666]',
    'read-only:hover:placeholder:text-[#666666]',
    'read-only:focus:bg-[#ededed]',
    'read-only:focus:border-[#666666]',
    'read-only:focus:placeholder:text-[#666666]',

    'dark:text-[#e6e6e6]',

    'dark:bg-[#1a1a1a]',
    'dark:border-[#999999]',
    'dark:placeholder:text-[#999999]',

    'dark:hover:bg-[#1a1a1a]',
    'dark:hover:border-[#999999]',
    'dark:hover:placeholder:text-[#999999]',

    'dark:focus:bg-[#1a1a1a]',
    'dark:focus:border-[#999999]',
    'dark:focus:placeholder:text-[#999999]',

    'dark:active:bg-[#1a1a1a]',
    'dark:active:border-[#999999]',

    'dark:data-[invalid=true]:bg-[#1a1a1a]',
    'dark:data-[invalid=true]:border-[#e7001e]',
    'dark:data-[invalid=true]:placeholder:text-[#999999]',
    'dark:data-[invalid=true]:hover:bg-[#1a1a1a]',
    'dark:data-[invalid=true]:hover:border-[#e7001e]',
    'dark:data-[invalid=true]:hover:placeholder:text-[#999999]',
    'dark:data-[invalid=true]:active:bg-[#1a1a1a]',
    'dark:data-[invalid=true]:active:border-[#e7001e]',
    'dark:data-[invalid=true]:active:placeholder:text-[#999999]',
    'dark:data-[invalid=true]:focus:bg-[#1a1a1a]',
    'dark:data-[invalid=true]:focus:border-[#e7001e]',
    'dark:data-[invalid=true]:focus:placeholder:text-[#999999]',

    'dark:disabled:bg-[#242424]',
    'dark:disabled:border-[#3d3d3d]',
    'dark:disabled:placeholder:text-[#999999]',
    'dark:disabled:hover:bg-[#242424]',
    'dark:disabled:hover:border-[#3d3d3d]',
    'dark:disabled:hover:placeholder:text-[#999999]',
    'dark:disabled:focus:bg-[#242424]',
    'dark:disabled:focus:border-[#3d3d3d]',
    'dark:disabled:focus:placeholder:text-[#999999]',

    'dark:read-only:bg-[#1a1a1a]',
    'dark:read-only:border-[#999999]',
    'dark:read-only:placeholder:text-[#999999]',
    'dark:read-only:hover:bg-[#1a1a1a]',
    'dark:read-only:hover:border-[#999999]',
    'dark:read-only:hover:placeholder:text-[#999999]',
    'dark:read-only:focus:bg-[#1a1a1a]',
    'dark:read-only:focus:border-[#999999]',
    'dark:read-only:focus:placeholder:text-[#999999]'
]);

export { inputStylesSAG, inputStylesSHS };
